import type { SVGProps } from 'react';
const SvgBrightnessMedium = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#brightness_medium_svg__a)">
      <path
        fill="currentColor"
        d="M20 15.31 23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69ZM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6Z"
      />
    </g>
    <defs>
      <clipPath id="brightness_medium_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBrightnessMedium;
